import { WprBaseObject } from '../../WprBaseObject';
import { WprBaseViewCore } from '../WprBaseViewCore';
import { IWprConfigOption } from './IWprConfigOption';

/**
 * コントロール定義オプション
 */
export class WprControlConfig extends WprBaseObject {
	// private 変数  ------------------------------------------------------------
	private m_ViewCore: WprBaseViewCore	= null;				// View情報
	private m_Name: string				= null;				// コントトール名
	private m_Min: number | string		= undefined;		// 最小値
	private m_Max: number | string		= undefined;		// 最大値
	private m_MinLength: number			= undefined;		// 最小文字数
	private m_MaxLength: number			= undefined;		// 最大文字数
	private m_UseChangeEvent: boolean	= true;				// 値変更イベント使用フラグ
	private m_Category: string			= null;				// カテゴリ
	private m_NotClear: boolean			= false;			// 値クリアフラグ
	private m_ActionList: string[]		= null;				// 入力チェック対象アクションリスト
	private m_DispAuthList: string[]	= null;				// 表示権限リスト
	private m_EnableAuthList: string[]	= null;				// 活性化権限リスト
	private m_EditClass?: string		= null;				// 編集時クラス名
	private m_NoEditClass?: string		= null;				// 未編集時クラス名
	private m_ErrorClass?: string		= null;				// 入力エラー時クラス名
	private m_EnableMode?: string		= null;				// 活性化モード
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** 最小文字数 */
	public get min(): number | string		{ return this.m_Min; 			}
	/** 最大文字数 */
	public get max(): number | string		{ return this.m_Max; 			}
	/** 最小文字数 */
	public get minLength(): number			{ return this.m_MinLength; 		}
	/** 最大文字数 */
	public get maxLength(): number			{ return this.m_MaxLength; 		}
	/** 値変更イベント使用フラグ */
	public get useChangeEvent(): boolean	{ return this.m_UseChangeEvent; }
	/** カテゴリ */
	public get category(): string			{ return this.m_Category; 		}
	/** 値クリアフラグ */
	public get notClear(): boolean			{ return this.m_NotClear; 		}
	/** 入力チェック対象アクション */
	public get actionList(): string[]		{ return this.m_ActionList; 	}
	/** 表示権限リスト */
	public get dispAuthList(): string[]		{ return this.m_DispAuthList; 	}
	/** 活性化権限リスト */
	public get enableAuthList(): string[]	{ return this.m_EnableAuthList; }
	/** 編集時クラス名 */
	public get editClass(): string			{ return this.m_EditClass; 		}
	/** 未編集時クラス名 */
	public get noEditClass(): string		{ return this.m_NoEditClass; 	}
	/** 入力エラー時クラス名 */
	public get errorClass(): string			{ return this.m_ErrorClass; 	}
	/** 活性化モード */
	public get enableMode(): string			{ return this.m_EnableMode; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(name: string, viewCore: WprBaseViewCore, config?: IWprConfigOption) {
		super();
		this.m_Name = name;
		this.m_ViewCore = viewCore;
		if (config) {
			if (config.min)
				this.m_Min = config.min;
			if (config.max)
				this.m_Max = config.max;
			if (config.minLength)
				this.m_MinLength = config.minLength;
			if (config.maxLength)
				this.m_MaxLength = config.maxLength;
			if (config.changeEvent)
				this.m_UseChangeEvent = config.changeEvent;
			if (config.category)
				this.m_Category = config.category;
			if (config.notClear)
				this.m_NotClear = config.notClear;
			if (config.action)
				this.m_ActionList = this.getActionList(config.action);
			if (config.dispAuth)
				this.m_DispAuthList = this.getAuthList(config.dispAuth);
			if (config.enableAuth)
				this.m_EnableAuthList = this.getAuthList(config.enableAuth);
			if (config.editClass)
				this.m_EditClass = config.editClass;
			if (config.noEditClass)
				this.m_NoEditClass = config.noEditClass;
			if (config.errorClass)
				this.m_ErrorClass = config.errorClass;
			if (config.enableMode)
				this.m_EnableMode = config.enableMode;
		}
	}
	// --------------------------------------------------------------------------

	// public メソッド  ---------------------------------------------------------
	/**
	 * アクション名リスト取得
	 * @param action アクション名
	 * @returns アクション名リスト
	 */
	private getActionList(action: string): string[] {
		const list = new Array();
		if (action.includes(',') === false) {
			list.push(action);
			/*
			if (this.m_ViewCore.viewInfo.checkAction(action) === true)
				list.push(action);
			else
				this.m_ViewCore.addErrorLog(`コントロールのActionの指定に誤りがあります。[${this.m_Name}][${action}}]`);
			*/
		}
		else {
			action.split(',').forEach(aname => {
				list.push(aname.trim());
				/*
				if (this.m_ViewCore.viewInfo.checkAction(aname.trim()) === true)
					list.push(aname.trim());
				else
					this.m_ViewCore.addErrorLog(`コントロールのActionの指定に誤りがあります。[${this.m_Name}][${aname}}]`);
				*/
			});
		}
		return list;
	}

	/**
	 * 権限名リスト取得
	 * @param action アクション名
	 * @returns アクション名リスト
	 */
	private getAuthList(authority: string): string[] {
		const list = new Array();
		if (authority.includes(',') === false) {
			if (this.FW.auth.checkAuthority(authority) === true)
				list.push(authority);
			else
				this.m_ViewCore.addErrorLog(`コントロールの権限の指定に誤りがあります。[${this.m_Name}][${authority}]`);
		}
		else {
			authority.split(',').forEach(aname => {
			if (this.FW.auth.checkAuthority(aname.trim()) === true)
				list.push(aname.trim());
			else
				this.m_ViewCore.addErrorLog(`コントロールの権限の指定に誤りがあります。[${this.m_Name}][${aname}]`);
			});
		}
		return list;
	}
	// --------------------------------------------------------------------------
}
